/**
 * @file 对外常量
 * @author zhanghaohan
 */

export const PLATFORMLIVEMAP = {
    2: 'KUAI_SHOU',
    3: 'MEI_TUAN'
};
export const PLATFORMMAP = {
    kuaishou: 2,
    meituan: 3,
    jd: 5
};
export const TASKTYPEMAP = {
    all: 1000,
    kuaishou: 1002,
    meituan: 1004
};
export const ACCOUNTTYPEMAP = {
    kuaishou: 'ELE_BUSSINESS',
    meituan: 'BUSSINESS'
};

export const SOURCEMAP = [
    {
        label: 'douyin',
        cnLabel: '抖音',
        value: 1
    },
    {
        label: 'kuaishou',
        cnLabel: '快手',
        value: 2
    },
    {
        label: 'meituan',
        cnLabel: '美团',
        value: 3
    },
    {
        label: 'taobao',
        cnLabel: '淘宝',
        value: 4
    },
    {
        label: 'jingdong',
        cnLabel: '京东',
        value: 5
    }
];

export const COMMENTKINDMAP = [
    {
        label: 'BARRAGE',
        cnLabel: '弹幕',
        value: 1
    },
    {
        label: 'ENTER',
        cnLabel: '进入直播间',
        value: 2
    },
    {
        label: 'FOLLOW',
        cnLabel: '关注',
        value: 3
    },
    {
        label: 'GIFT',
        cnLabel: '送礼物',
        value: 4
    },
    {
        label: 'LIKE',
        cnLabel: '点赞',
        value: 5
    }
];